import _, { indexOf, values } from 'lodash';
import { createSelector } from 'reselect';

import {
  get,
  post,
  put,
  del,
} from 'utils/fetch';

import { RequestState } from 'constants/constants';
import { listReducer, listWithout, createListSelector } from 'utils/list';

import { selectCurrentAccountId } from 'store/models/Account';



// ======================
// HELPERS
// ====================== 




// ======================
// ACTIONS
// ====================== 
export const FETCH_TEAMS = 'FETCH_TEAMS';
export const CREATE_TEAM = 'CREATE_TEAM';
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const DELETE_TEAM = 'DELETE_TEAM';


// ======================
// SELECTORS
// ====================== 
export const selectTeams = state => state.models.teams;




// ======================
// MODEL
// ====================== 
const Team = {
  actions: {
    fetchTeams: accountId => (dispatch, getState) => {
      accountId = accountId ?? selectCurrentAccountId(getState());
      return get({
        url: '/api/account/:accountId/teams',
        params: { accountId },
        dispatch,
        action: FETCH_TEAMS,
      })
    },

    createTeam: values => dispatch => post({
      url: '/api/team',
      body: values,
      dispatch,
      action: CREATE_TEAM,
    }),

    updateTeam: (teamId, values) => dispatch => put({
      url: '/api/team/:teamId',
      params: { teamId },
      body: values,
      dispatch,
      action: UPDATE_TEAM,
    }),

    deleteTeam: teamId => dispatch => del({
      url: '/api/team/:teamId',
      params: { teamId },
      dispatch,
      action: DELETE_TEAM,
    }),
  },

  spec: {
    teams: {},
  },

  reducer: (state, type, body, action, json) => {
    if(action.url && action.result !== RequestState.SUCCESS)
      return state;

    if(body && body.teams) {
      state = {
        ...state,
        teams: {
          ...state.teams,
          ..._.keyBy(body.teams, '_id'),
        }
      };
    }

    switch(type) {
      case DELETE_TEAM:
        return {
          ...state,
          teams: _.omit(state.teams, action.params.teamId),
        }
    }
    return state;
  },
}
export default Team;